module.exports = __webpack_public_path__ + "img/m-banner-kkmucesc-ko-KR.290c2fbe.png";